import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query business analytics info by year
 */
export default async function queryBusinessData(year: number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/data_dashboard/dashboard/${year}`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to get business info by year: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }

  return res.json();
}
